import styled from 'styled-components';
import { baseTheme } from '../../../../../../global/styles/theme';

export const CardContainer = styled.div<{
  accentColor?: string;
  accentBackground?: string;
  accentBorder?: string;
  isPending?: boolean;
}>`
  background: ${({ accentBackground, isPending }) =>
    accentBackground || (isPending ? '#f2f7ff' : baseTheme.colors.white)};
  border: 1px solid
    ${({ accentBorder, isPending }) =>
      accentBorder || (isPending ? '#bcd6f2' : baseTheme.colors.stroking)};
  border-left: 4px solid
    ${({ accentBorder, isPending }) =>
      isPending
        ? baseTheme.colors.mainLightBlue
        : accentBorder || 'transparent'};
  border-radius: 16px;
  overflow: hidden;
  transition: background 0.3s ease, border-color 0.3s ease;
`;

export const CardInfo = styled.div`
  display: flex;
  gap: 14px;
  padding: 16px;

  .image-container {
    width: 68px;
    height: 68px;
    border-radius: 12px;
    border: 1px solid ${baseTheme.colors.stroking};
    background: ${baseTheme.colors.white};
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .info-container {
    flex: 1;
    min-width: 0;
  }

  .name-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex-wrap: wrap;
  }

  .name {
    font-size: 15px;
    font-weight: 700;
    color: ${baseTheme.colors.primary};
    line-height: 1.3;
  }

  .quantity-badge {
    padding: 2px 8px;
    border-radius: 8px;
    background: ${baseTheme.colors.background};
    font-size: 14px;
    font-weight: 700;
    color: ${baseTheme.colors.mainLightBlue};
    white-space: nowrap;
  }

  .packing {
    margin-top: 2px;
    font-size: 13px;
    color: ${baseTheme.colors.secondary};
  }

  .manufacturer {
    margin-top: 2px;
    font-size: 12px;
    color: ${baseTheme.colors.tertiary};
  }

  .price {
    margin-top: 4px;
    font-size: 13px;
    font-weight: 600;
    color: ${baseTheme.colors.primary};
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex-wrap: wrap;
  }

  .price-old {
    color: ${baseTheme.colors.tertiary};
    text-decoration: line-through;
    font-weight: 500;
  }

  .price-new {
    color: ${baseTheme.colors.primary};
    font-weight: 700;
  }
`;

export const MarkStatusHeader = styled.div`
  background: ${baseTheme.colors.mainLightBlue};
  color: ${baseTheme.colors.white};
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
`;

export const StatusButtonsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid ${baseTheme.colors.stroking};
`;

export const StatusButton = styled.button<{ buttonColor: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 2px;
  background: transparent;
  border: none;
  border-left: 1px solid ${baseTheme.colors.stroking};
  cursor: pointer;
  transition: background 0.15s;

  &:first-child {
    border-left: none;
  }

  &:hover {
    background: ${baseTheme.colors.background};
  }

  .status-icon {
    font-size: 20px;
    line-height: 1;
  }

  .status-text {
    font-size: 11px;
    font-weight: 700;
    color: ${({ buttonColor }) => buttonColor};
    text-align: center;
  }
`;

export const SelectedStatusBar = styled.div<{ statusColor: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid ${baseTheme.colors.stroking};

  .status-info {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .status-icon {
    font-size: 18px;
    line-height: 1;
  }

  .status-label {
    font-size: 14px;
    font-weight: 700;
    color: ${({ statusColor }) => statusColor};
  }

  .status-detail {
    padding: 3px 10px;
    border-radius: 8px;
    background: ${baseTheme.colors.white};
    font-size: 13px;
    font-weight: 600;
    color: ${({ statusColor }) => statusColor};
  }

  .change-button {
    padding: 6px 14px;
    border-radius: 8px;
    border: 1px solid ${({ statusColor }) => statusColor};
    background: ${baseTheme.colors.white};
    font-size: 13px;
    font-weight: 600;
    color: ${({ statusColor }) => statusColor};
    cursor: pointer;
  }
`;

export const NeedReceiptRow = styled.div<{ isChecked?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 10px 16px 14px;
  padding: 8px 14px;
  border-radius: 12px;
  border: 1.5px solid ${({ isChecked }) => (isChecked ? '#1fa069' : '#ea580c')};
  background: ${({ isChecked }) => (isChecked ? '#f0fdf4' : '#fff7ed')};
  transition: background 0.15s, border-color 0.15s;

  .receipt-label {
    font-size: 13px;
    font-weight: 700;
    color: ${({ isChecked }) => (isChecked ? '#1fa069' : '#ea580c')};
  }
`;
